import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
    position: relative;
    z-index: 13;
    height: 0px;
`;

const RoleButton = styled.div`
    user-select: none;
    background-color: rgb(255, 255, 255);
    color: rgb(117, 117, 117);
    cursor: default;
    position: absolute;
    top: 18px;
    line-height: 0.78;
    left: 22px;
    margin: 0px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(242, 242, 242);
    border-image: initial;
    border-radius: 3px;
    padding: 6px 9px;

    &:hover {
        cursor: pointer;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(196, 196, 196);
        border-image: initial;
    }

    &.right {
        left: initial;
        right: 22px;
    }

    .svg-prev {
        height: 19px;
        width: 19px;
        display: block;
        fill: rgb(130, 136, 138);
    }

    .svg-next {
        height: 19px;
        width: 19px;
        fill: rgb(130, 136, 138);
        display: block;
    }
`;

function NavbarElement({ onPreviousClick, onNextClick, ...props }) {
    const onClickPrev = useCallback(() => onPreviousClick(), [onPreviousClick]);
    const onClickNext = useCallback(() => onNextClick(), [onNextClick]);

    return (
        <Wrapper className={props.className}>
            <React.Fragment>
                {props.showPreviousButton && (
                    <RoleButton
                        role="button"
                        onClick={onClickPrev}
                        aria-label={props.labels.previousMonth}
                    >
                        <svg className="svg-prev" focusable="false" viewBox="0 0 1000 1000">
                            <path d="M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z" />
                        </svg>
                    </RoleButton>
                )}
            </React.Fragment>
            <React.Fragment>
                {props.showNextButton && (
                    <RoleButton
                        role="button"
                        onClick={onClickNext}
                        aria-label={props.labels.nextMonth}
                        className="right"
                    >
                        <svg className="svg-next" focusable="false" viewBox="0 0 1000 1000">
                            <path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" />
                        </svg>
                    </RoleButton>
                )}
            </React.Fragment>
        </Wrapper>
    );
}

export default NavbarElement;

NavbarElement.propTypes = {
    onPreviousClick: PropTypes.func.isRequired,
    onNextClick: PropTypes.func.isRequired,
    labels: PropTypes.shape({
        previousMonth: PropTypes.string.isRequired,
        nextMonth: PropTypes.string.isRequired,
    }).isRequired,
    className: PropTypes.string.isRequired,
    showPreviousButton: PropTypes.bool.isRequired,
    showNextButton: PropTypes.bool.isRequired,
};
